import { usePayrollExportsContext } from 'modules/bookkeepers/pages/Clients/PayrollExports'
import { usePolicyPeriods } from 'modules/payroll_bundle/lib/policyPeriodsContext'
import SyncModal from 'modules/payroll_integrations_a3innuva/components/SyncModal'

const SyncModalWithPolicyPeriod = () => {
  const { selectedCompany, onClose } = usePayrollExportsContext()
  const selectedCompanyId = selectedCompany

  const policyPeriodsContext: PolicyPeriodsContext = usePolicyPeriods()
  type FetchDataParams = {
    bookkeeper_view?: boolean
  } | null

  type PolicyPeriodsContext = {
    policyPeriodCollection?: {
      previousFetchDataParams?: FetchDataParams
    }
  }

  const isProfessionals =
    policyPeriodsContext?.policyPeriodCollection?.previousFetchDataParams?.bookkeeper_view ?? false

  const content = (
    <SyncModal
      onClose={onClose}
      selectedCompany={selectedCompanyId}
      isProfessionals={isProfessionals}
    />
  )

  return content
}

export default SyncModalWithPolicyPeriod
